import FeatureMiddleware from '@/middleware/FeatureMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';
import { INBOX_ABILITY } from '@/policies/InboxPolicy.js';

/**
 * The three inbox lists share one page; each route only selects its tab. The list URLs are kept
 * so existing links (bell, emails, bookmarks) still land on the right tab.
 */
const inboxListRoute = ({ path, name, title, section, features = ['INBOX'] }) => ({
    path,
    name,
    component: () => import('@/pages/inbox/InboxPage.vue'),
    meta: {
        title,
        inboxSection: section,
        // On phones "⌂ / Inbox" only repeats the page title (honoured by AppBreadcrumb).
        hideBreadcrumbOnPhones: true,
        dataTablePage: true,
        middleware: [GateKeeperMiddleware],
        ability: INBOX_ABILITY,
    },
    beforeEnter: features.map(feature => FeatureMiddleware(feature)),
});

export default [
    {
        path: '/inbox',
        name: 'inbox',
        redirect: { name: 'inbox-announcements' },
    },
    inboxListRoute({
        path: '/inbox/announcements',
        name: 'inbox-announcements',
        title: 'Announcements',
        section: 'announcements',
    }),
    inboxListRoute({
        path: '/inbox/discussions',
        name: 'inbox-discussions',
        title: 'Discussions',
        section: 'discussions',
    }),
    inboxListRoute({
        path: '/inbox/messages',
        name: 'inbox-messages',
        title: 'Messages',
        section: 'messages',
        features: ['INBOX', 'MESSAGES'],
    }),
    {
        path: '/inbox/messages/:messageId/',
        name: 'message-view',
        component: () => import('@/components/inbox/messages/MessageView.vue'),
        props: true,
        meta: {
            title: 'Message',
            middleware: [GateKeeperMiddleware],
            ability: INBOX_ABILITY,
        },
        beforeEnter: [FeatureMiddleware('INBOX'), FeatureMiddleware('MESSAGES')],
    },
    {
        path: '/inbox/announcements/course/:courseId/:type/:announcementId',
        name: 'announcement-view',
        component: () => import('@/components/inbox/announcements/AnnouncementView.vue'),
        meta: {
            title: 'Announcement',
            middleware: [GateKeeperMiddleware],
            ability: INBOX_ABILITY,
        },
        beforeEnter: FeatureMiddleware('INBOX'),
    },
];
